import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const projectTeamManagementPlugin = createPlugin({
  id: 'project-team-management',
  routes: {
    root: rootRouteRef,
  },
});

export const EntityProjectTeamManagementContent = projectTeamManagementPlugin.provide(
  createRoutableExtension({
    name: 'EntityProjectTeamManagementContent',
    component: () =>
      import('./components/ProjectTeamManagement').then(m => m.ProjectTeamManagement),
    mountPoint: rootRouteRef,
  }),
);
